import { inject, Injectable } from '@angular/core';
import { SessionStorage, SessionStorageService } from '@mwe/utils';
import { OfferStatusDTO } from '@mwe/models';

const offerStatusKey = 'offerConfirmation_offerStatus';

@Injectable({ providedIn: 'root' })
export class OfferConfirmationStateService {
  private storage = inject(SessionStorageService);

  clearAll(): void {
    this.storage.clear(offerStatusKey);
  }

  @SessionStorage(offerStatusKey)
  private _offerStatus: OfferStatusDTO;

  get offerStatus(): OfferStatusDTO {
    return this._offerStatus;
  }

  set offerStatus(value: OfferStatusDTO) {
    this._offerStatus = value;
  }
}
